import * as z from 'zod';

export const existingGuestData = z
    .object({
        firstName: z.string(),
        lastName: z.string(),
        company: z.string().nullable(),
    })
    .nullable();

export type ExistingGuestData = z.infer<typeof existingGuestData>;

export const guestBookingData = z
    .object({
        guestBookingFirstName: z.string().nullable(),
        guestBookingLastName: z.string().nullable(),
        guestBookingCompany: z.string().nullable(),
        guestBookingInitials: z.string().nullable(),
        guestBookingAnonymised: z.boolean(),
        guestBookingEmail: z.string().nullable().optional(),
    })
    .nullable();

export type GuestBookingData = z.infer<typeof guestBookingData>;

/**
 * Whether the current user is allowed to see the guest's data.
 * The backend nulls the guest fields when the viewer lacks access, so data
 * presence is the permission signal. `guestBookingAnonymised` only states that
 * the booking is anonymised towards other users and must not drive rendering.
 */
export function hasVisibleGuestData(data: GuestBookingData | null | undefined): boolean {
    return data?.guestBookingFirstName != null || data?.guestBookingLastName != null;
}
